import { type } from "arktype";

export const ForgotPasswordFormSchema = type({
  email: "string.email",
});

export type ForgotPasswordFormValues = typeof ForgotPasswordFormSchema.infer;

export const defaultForgotPasswordFormValues: ForgotPasswordFormValues = {
  email: "",
};
